import React from 'react';
import {BrowserRouter as Router,Routes,Route,Navigate} from 'react-router-dom';
import {motion} from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import Topics from './pages/Topics';
import NotFound from './pages/NotFound';

// Blog Posts
import VaporBarrier from './pages/topics/VaporBarrier';
import WindowGlazing from './pages/topics/WindowGlazing';
import EconomicalBuilding from './pages/topics/EconomicalBuilding';
import PurchaseAudit from './pages/topics/PurchaseAudit';
import SoundInsulation from './pages/topics/SoundInsulation';
import SheepWoolInsulation from './pages/topics/SheepWoolInsulation';
// Generic Post
import SheepWoolProsCons from './pages/topics/SheepWoolProsCons';
// New Pros/Cons Post
import ModernInsulation from './pages/topics/ModernInsulation';
import ConstructionCosts from './pages/topics/ConstructionCosts';
import DrywallGuide from './pages/topics/DrywallGuide';
import RentVsBuy from './pages/topics/RentVsBuy';
import SoundInsulationDrywall from './pages/topics/SoundInsulationDrywall';
import RoofInsulation from './pages/topics/RoofInsulation';
import EnergyRenovation from './pages/topics/EnergyRenovation';
import StrawInsulation from './pages/topics/StrawInsulation';
import UnverbindlichesAngebot from './pages/topics/UnverbindlichesAngebot';
import Kerndaemmung from './pages/topics/Kerndaemmung';
import Kellerdeckendaemmung from './pages/topics/Kellerdeckendaemmung';
import TrockenbauAnfrage from './pages/topics/TrockenbauAnfrage';
import DrywallFilling from './pages/topics/DrywallFilling';
// NEUER BEITRAG
import FundingNRW from './pages/topics/FundingNRW';

// Service Pages
import Trockenbau from './pages/services/Trockenbau';
import Daemmtechnik from './pages/services/Daemmtechnik';
import Innentuer from './pages/services/Innentuer';
import Bodenbelag from './pages/services/Bodenbelag';
import Maler from './pages/services/Maler';
import Designboden from './pages/services/Designboden';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <ScrollToTop />
        <Header />
        <motion.main 
          className="flex-grow"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{duration: 0.5}}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ueber" element={<About />} />
            
            {/* Blog Hauptseite */}
            <Route path="/blog" element={<Topics />} />
            
            {/* Blog Artikel Struktur */}
            <Route path="/blog/dampfbremse-holzdecke" element={<VaporBarrier />} />
            <Route path="/blog/fensterverglasung-2026" element={<WindowGlazing />} />
            <Route path="/blog/wirtschaftliches-bauen" element={<EconomicalBuilding />} />
            <Route path="/blog/ankaufspruefung-mehrfamilienhaus" element={<PurchaseAudit />} />
            <Route path="/blog/schallschutz-holzbalkendecke" element={<SoundInsulation />} />
            
            {/* BEIDE SCHAFWOLLE POSTS AKTIV */}
            <Route path="/blog/schafwolle-daemmung" element={<SheepWoolInsulation />} />
            <Route path="/blog/schafwolle-daemmung-vorteile-nachteile" element={<SheepWoolProsCons />} />
            
            <Route path="/blog/moderne-daemmtechnik" element={<ModernInsulation />} />
            <Route path="/blog/baukosten-abschaetzen" element={<ConstructionCosts />} />
            <Route path="/blog/trockenbau-leitfaden" element={<DrywallGuide />} />
            <Route path="/blog/mieten-oder-kaufen" element={<RentVsBuy />} />
            <Route path="/blog/schallschutz-trockenbau" element={<SoundInsulationDrywall />} />
            <Route path="/blog/dachdaemmung-richtig-planen" element={<RoofInsulation />} />
            <Route path="/blog/energetische-sanierung-heinsberg" element={<EnergyRenovation />} />
            <Route path="/blog/stroh-einblasdaemmung" element={<StrawInsulation />} />
            <Route path="/blog/unverbindliches-angebot-innenausbau" element={<UnverbindlichesAngebot />} />
            <Route path="/blog/kerndaemmung" element={<Kerndaemmung />} />
            <Route path="/blog/kellerdeckendaemmung" element={<Kellerdeckendaemmung />} />
            <Route path="/blog/trockenbau-anfrage-richtig-stellen" element={<TrockenbauAnfrage />} />
            <Route path="/blog/spachtelarbeiten-trockenbau-fehler-vermeiden" element={<DrywallFilling />} />
            <Route path="/blog/foerderprogramme-hausbesitzer-nrw-2026" element={<FundingNRW />} /> {/* NEUE ROUTE */}

            {/* Legacy Redirects */}
            <Route path="/themengebiete" element={<Navigate to="/blog" replace />} />
            <Route path="/services/trockenbau" element={<Navigate to="/trockenbau" replace />} />
            <Route path="/services/daemmtechnik" element={<Navigate to="/daemmtechnik" replace />} />
            <Route path="/services/innentuer" element={<Navigate to="/innentuer" replace />} />
            <Route path="/services/bodenbelag" element={<Navigate to="/bodenbelag" replace />} />
            <Route path="/services/maler" element={<Navigate to="/maler" replace />} />
            <Route path="/services/designboden" element={<Navigate to="/designboden" replace />} />
            <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
            <Route path="/about" element={<Navigate to="/ueber" replace />} />

            {/* Service Pages */}
            <Route path="/services" element={<Services />} />
            <Route path="/trockenbau" element={<Trockenbau />} />
            <Route path="/daemmtechnik" element={<Daemmtechnik />} />
            <Route path="/innentuer" element={<Innentuer />} />
            <Route path="/bodenbelag" element={<Bodenbelag />} />
            <Route path="/maler" element={<Maler />} />
            <Route path="/designboden" element={<Designboden />} />

            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />

            {/* Catch-All Route für 404 Fehler */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </motion.main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;